import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ReactScroll from 'react-scroll';
import _ from 'underscore';
import { CARAT_WEIGHT_SUGGESTION_MAX_VALUE } from '../../constans/index'
import Validator from 'lib/validators'
import I18n from 'lib/i18n/i18n';

import {dataAutomationAttr, isMobile} from 'helpers/ApplicationHelper';



class Field extends Component {
    constructor(props) {
        super(props);

        this.state = {
            suggestions: [],
            name: props.name,
            className: props.className,
            label: props.label,
            optional: props.optional,
            topText: props.topText,
            additionalText: props.additionalText,
            keysPressed: props.keysPressed,
            tip: props.tip,
            type: props.type,
            options: props.options,
            value: props.value,
            minValue: props.minValue,
            onUpdateField: props.onUpdateField,
            scrollToOnOpen: props.scrollToOnOpen,
            selectedValue: props.defaultValue || 0,
            integer: props.integer || false,
            hasValue: false,
            hasValidValue: true,
            openInProgress: false,
            autoSelectOption: props.autoSelectOption,
            moreDetailsValue: ""
        };

        this.suggestionsShownFlag = false;

        this.renderOptions = this.renderOptions.bind(this);
        this.selectChange = this.selectChange.bind(this);
        this.inputSet = this.inputSet.bind(this);
        this.toggleInput = this.toggleInput.bind(this);
        this.onMoreDetailsChange = this.onMoreDetailsChange.bind(this)
        this.setMoreDetails = this.setMoreDetails.bind(this)
        this.detailsInputRef = React.createRef()
    }

    componentDidMount(){
        if(this.state.value){
            switch (this.state.type){
                case 'select':
                    let selectedOption = _.findWhere(this.state.options, {value: this.state.value});
                    if ( selectedOption ) {
                        this.selectChange(selectedOption);
                    } else {
                        // for fields with 'moreDetails' input.
                        selectedOption = this.state.options.find((o) => this.state.value.startsWith(o.value))
                        const moreDetails = this.state.value.replace(selectedOption.value+"_","")
                        this.setMoreDetailsValue(selectedOption, moreDetails)
                        this.setState({
                            selectedValue: selectedOption.value, 
                            hasValue: true,
                            detailsInput: selectedOption.requires_more_details
                        })
                        this.state.onUpdateField(this.state.value, selectedOption.label + " #" + moreDetails)
                    }
                    
                    break;
                case 'number':
                    this.inputUpdateValue(this.state.value);
            }
            this.setState({isOpen: false});
        }
        if(this.props.defaultValue){
            this.props.setDefaultValue(this.props.defaultValue);
        }

        if(this.props.autoSelectOption){
            this.refs[this.props.autoSelectOption].click();
        }
    }

    openTimeoutLock;

    componentWillReceiveProps(newProps){
        if(!newProps.submitFormInProcess){
            if(newProps.isOpen) {
                // this.setState({openInProgress: true});
                setTimeout(()=>{
                    // this.setState({openInProgress: false});
                    if(isMobile() && this.state.scrollToOnOpen){
                        ReactScroll.animateScroll.scrollTo(ReactDOM.findDOMNode(this).offsetTop-40, {
                            duration: 600,
                            delay: 0,
                            smooth: true
                        });
                    }
                }, 1000);
            }
            if(this.props.isOpen !== newProps.isOpen) {
                clearTimeout(this.openTimeoutLock);
                this.setState({openInProgress: true});
                this.openTimeoutLock = setTimeout(() => {
                    this.setState({openInProgress: false});
                }, 1000);
            }

            // hide brand when 'loose diamond' is selected
            if(this.state.name === 'diamond_brand_2') {
                this.setState({type: newProps.isLooseDiamond ? 'hidden' : this.props.type}); // fall back to original type, e.g. 'select'
            }
        }
    }

    renderOptions(option) {
        return (<div key={option.value}
                     className={`Select-option ${option.className} ${this.state.selectedValue === option.value  ? 'is-selected' : ''}`}
                     data-automation={dataAutomationAttr(option.label)}
                     onClick={()=>{this.selectChange(option)}}
                     ref={`${option.value}`}><span>{option.label}</span></div>)
    }

    selectChange(option){
        this.setState({value: option.label});
        this.setState({selectedValue: option.value});
        if ( option.requires_more_details ) {
            this.setState({
                detailsInput: option.requires_more_details,
            })
            this.setMoreDetailsValue(option,this.state.moreDetailsValue)
            setTimeout(() => {
                this.detailsInputRef.current.focus()
            },100)
        } else {
            this.setState({detailsInput: false, hasValue: true})
            this.state.onUpdateField(option.value, option.label);
        }
    }

    setMoreDetailsValue(option, moreDetails) {
        const newValue = option.label + " #" + moreDetails
        this.setState({
            value: newValue,
            moreDetailsValue: moreDetails,
            hasValue: this.verifyRegexValue(option.value + "_" + moreDetails)
        })
    }

    onMoreDetailsChange(e) {
        const moreDetails = e.target.value
        const option = this.state.options.find((o) => o.value === this.state.selectedValue)
        this.setMoreDetailsValue(option, moreDetails)
    }

    onInputChange(e) {

        this.setState({value: '', hasValue: false, hasValidValue: false, suggestions: []});
        const shorter = e.target.value.length < this.state.value.length,
            cond1 = (/^0[^.]/).test(e.target.value), // starts with 0 with no succeeding decimal point
            cond2 = (/^[.]/).test(e.target.value); // starts with a decimal point
        shorter ?
            (cond1 || cond2) && (e.target.value = e.target.value.substring(1))
            :
            (cond1 && (e.target.value = '0.' + e.target.value.substr(1)))
            ||
            (cond2 && (e.target.value = '0' + e.target.value));
    }

    onKeyPress(e) {
        e.target.dataset.keysPressed += e.key;
        this.setState({keysPressed: e.target.dataset.keysPressed});
        if (this.state.integer && e.charCode === 46) {e.preventDefault();}
        if (e.charCode === 13) {
            e.preventDefault();
            this.inputUpdateValue(e.target.value, Validator.validateNumber(e.target.value, this.state.minValue));
        }
        this.props.afterKeysPressed(e.target.dataset.keysPressed);
    }

    inputUpdateValue(value, validate = true){
        this.state.onUpdateField(undefined);
        if (!value || !validate) {
            this.setState({value: value, hasValidValue: false, hasValue: false});
            return false;
        } else {
            const suggestions = [];
            if (this.props.withSuggestions && value >= 10) {
                !this.suggestionsShownFlag && (this.suggestionsShownFlag = true) && this.props.suggestionsShown();
                for (let divisor = 1; suggestions.length < 3 && value / divisor >= 0.1; divisor *= 10) {
                    if (value / divisor <= CARAT_WEIGHT_SUGGESTION_MAX_VALUE) {
                        const strCheckVal = (value / divisor + Number.EPSILON).toString(),
                            decimalPointIdx = strCheckVal.indexOf('.'),
                            decimalDigitsCount = decimalPointIdx !== -1 ? strCheckVal.length - decimalPointIdx - 1 : 0;
                        suggestions.unshift(parseFloat(strCheckVal.substr(0, strCheckVal.length - decimalDigitsCount + 2)));
                    }
                }
                this.setState({suggestions});
            } else {
                this.setState({hasValidValue: true, hasValue: true, value, suggestions}, this.inputSet);
            }
        }
    }

    onSuggestionClick(e) {
        const value = e.target.attributes['data-value'].value;
        this.refs.inputNumber.value = value;
        this.setState({value, hasValidValue: true, hasValue: true, suggestions: []}, this.inputSet);
    }

    inputSet(){
        this.refs.inputNumber.blur();
        let value = this.state.value;
        let valueChanged = this.props.value !== value;
        if(this.state.hasValidValue && (value || valueChanged)){
            this.state.onUpdateField(value, value);
        }
    }

    setMoreDetails(e) {
        e.target.blur()
        this.state.onUpdateField(this.state.selectedValue+"_"+e.target.value, this.state.value)
    }

    verifyRegexValue(value) {
        if (!this.props.verificationRegex) {
            return true
        }
        return !!value.match(this.props.verificationRegex)
    }

    toggleInput(fieldName){
        if(!this.state.openInProgress){
            clearTimeout(this.openTimeoutLock);
            this.state.openInProgress = true;
            this.props.onToggleField(fieldName);
            this.openTimeoutLock = setTimeout(()=>{
                this.setState({openInProgress: false});
            }, 1000);
        }
    }

    render() {
        let openCloseCSS = (() => {
            let openCloseCSS = [];
            openCloseCSS.push(this.props.isOpen ? 'is-open' : 'closed');
            openCloseCSS.push(this.props.isOpen || this.state.openInProgress ? 'open-really' : '');
            openCloseCSS.push(!this.props.isOpen && !this.state.openInProgress ? 'closed-really' : '');
            return openCloseCSS.join(' ');
        })();

        let option = this.state.options.find((o) => o.value === this.state.selectedValue)

        if(this.state.type && this.state.type === 'hidden'){
            return(
                <input type="hidden" name={this.state.name} value={this.state.value} />
            )
        }
        let hasIncorrectSelectedValue = this.props.fieldIsFirstInvalid;

        if(this.state.type && this.state.type === 'select'){
            return(
                <div className={`field ${this.state.className} ${this.state.hasValue ? 'has-value' : ''}
                 ${hasIncorrectSelectedValue && !this.state.detailsInput ? 'has-incorrect-selected-value' : ''} ${openCloseCSS}`}>
                    <div className="arrow-zone" onClick={this.toggleInput}><span /></div>
                    <label onClick={()=>{this.toggleInput(this.state.name)}}>
                        {!this.state.hasValue ?
                        <React.Fragment>
                            {this.state.label}
                            {this.state.topText ? <span className="description-text">&nbsp;({this.state.topText})</span> : ''}
                            {/*removed optional as requested in jira 10070 uncomment if you want it back*/}
                            {/*{this.state.optional ? <span className="optional"> - {I18n.getString('submitForm::optional')} </span> : ""}*/}
                        </React.Fragment> :
                        <div>
                            <span className="property">{this.state.label}:</span>
                            <span className="property-value">{this.state.value}</span>
                        </div>}
                    </label>
                    <div className={`input-wrapper ${this.props.isOpen ? 'open' : 'closed'}`}>
                        <div className="Select">
                            <div className="Select-menu-outer">
                                <div className={`Select-menu clearfix ${!this.state.tip ? 'no-tip' : ''}`}>
                                    {this.state.options.map(this.renderOptions)}
                                </div>
                                {this.state.detailsInput ? <div className="Select-menu more-details">
                                    <label className={hasIncorrectSelectedValue ? 'has-incorrect-selected-value' : ''}>
                                        {this.state.detailsInput}
                                    </label>
                                    <input ref={this.detailsInputRef}
                                        type="text" autoComplete="off"
                                        name="more-details" 
                                        onChange={this.onMoreDetailsChange}
                                        onBlur={this.setMoreDetails}
                                        value={this.state.moreDetailsValue}
                                        placeholder={option.moreDetailsPlaceholder || ""}
                                    />
                                </div> : null}
                                {this.state.tip ? <div className="tip"><span>{I18n.getString('submitForm::tip')}: {this.state.tip}</span></div> : ''}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if(this.state.type && this.state.type === 'number'){
            const inputCaratWeight = this.refs.inputNumber;
            return(
                <div className={`field ${this.state.className} ${this.state.hasValue ? 'has-value' : ''}
                 ${hasIncorrectSelectedValue && 'has-incorrect-selected-value'} ${openCloseCSS}`}>
                    <div className="arrow-zone" onClick={this.toggleInput}><span /></div>
                    <label onClick={()=>{this.toggleInput(this.state.name)}}>{!this.state.hasValue ? this.state.label : <div><span className="property">{this.state.label}:</span><span className="property-value">{this.state.value}</span></div>} {this.state.topText ? <span className="description-text">({this.state.topText})</span> : ''}</label>
                    <div className={`input-wrapper input-wrapper-no-select ${this.props.isOpen ? '' : 'closed'}`}>
                        <input
                            id="input-carat-weight"
                            ref="inputNumber"
                            type="number"
                            name={this.state.name}
                            step="0.01"
                            keyspressed={this.state.keysPressed}
                            data-keys-pressed=''
                            onFocus={event => {event.preventDefault();}}
                            onChange={this.onInputChange.bind(this)}
                            onKeyPress={this.onKeyPress.bind(this)}
                            onBlur={e => {
                                this.inputUpdateValue(e.target.value, Validator.validateNumber(e.target.value, this.state.minValue));
                            }}
                        />
                        <span className="additional-text">{this.state.additionalText}</span>
                        <div className="rightImage"></div>
                        {
                            this.state.suggestions.length ?
                                (
                                    inputCaratWeight && inputCaratWeight.classList.add('suggestions-visible') ||
                                    <div id='suggestions-wrapper'>
                                        {
                                            this.state.suggestions.map((suggestion, idx) => {
                                                return <div className="suggestion-wrapper" key={idx} data-value={suggestion} onClick={this.onSuggestionClick.bind(this)}><span className="suggestion">{suggestion + 'CT'}</span></div>
                                            })
                                        }
                                    </div>
                                )
                                :
                                inputCaratWeight && inputCaratWeight.classList.remove('suggestions-visible') || null
                        }
                        {this.state.tip ? <div className="tip"><span>{I18n.getString('submitForm::tip')}: {this.state.tip}</span></div> : ''}
                        <div className="bottom" />
                    </div>
                </div>
            )
        }

        return(
            <div className={this.state.className}>
                <label>{this.state.label}</label>
            </div>
        )
    }
}

Field.defaultProps = {
    name: undefined,
    className: undefined,
    label: undefined,
    additionalText: undefined,
    type: undefined,
    options: [],
    value: '',
    minValue: undefined,
    onUpdateField: function () {
        return undefined;
    },
    autoSelectOption: null
};

Field.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    additionalText: PropTypes.string,
    type: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.string,
    minValue: PropTypes.number,
    onUpdateField: PropTypes.func,
    suggestions: PropTypes.array
};

export default Field;